import { makeEnvironmentProviders } from "@angular/core";
import { msalHashbrownMiddleware, MsalHashbrownMiddleware } from "./hashbrown-msal-middleware";
import { provideHashbrown } from "@hashbrownai/angular";

export function provideHashbrownWithMsalMiddleware(baseUrl: string): ReturnType<typeof makeEnvironmentProviders> {
    return makeEnvironmentProviders([
        MsalHashbrownMiddleware,
        provideHashbrown({
            baseUrl,
            middleware: [msalHashbrownMiddleware(baseUrl)]
        })
    ]);
}
